import "./CompanyNewFinancialsStyles.scss";
import $ from "jquery";
import keycode from "keycode";
import { dnbComLog, getViewportIsMobile, getWindowDigitalData, getWindowUnderscoreSatellite, LogSeverity } from "../FunctionsCore";
// Main menu
const changeTab = ($sourceElement) => {
    const activeClass = "active";
    const ariaExpandedAttribute = "aria-expanded";
    const ariaSelectedAttribute = "aria-selected";
    const tabContentClass = "tab-content";
    const $parent = $sourceElement.parent();
    $parent
        .find(`.${activeClass}`)
        .attr(ariaSelectedAttribute, "false")
        .removeClass(activeClass);
    $sourceElement
        .addClass(activeClass)
        .attr(ariaSelectedAttribute, "true");
    const $next = $parent.next();
    $next
        .find(`.${tabContentClass}`)
        .attr(ariaExpandedAttribute, "false")
        .hide();
    $next
        .find(`.${tabContentClass}:eq(${$sourceElement.index()})`)
        .show()
        .attr(ariaExpandedAttribute, "true");
};
const companyNewFinancials = () => {
    // Submenu
    const changeTabIs = (sourceElement) => {
        // Store the value of data-vtab
        const tabSelected = $(sourceElement).attr("data-vtab");
        // Remove active class and set aria-selected value to false for currently selected button
        $(".tabbed-nav-is button.vTabBold").removeClass("vTabBold").attr("aria-selected", "false");
        // Remove marker from active graph
        $(".tabbed-nav-is-content .tab-content-is.active").removeClass("active");
        // Hide content
        $(".tabbed-nav-is-content .tab-content-is").hide();
        // Show newly selected graph, and add active class and aria-selected true to button
        $(`button[data-vtab=${tabSelected}]`).addClass("vTabBold").attr("aria-selected", "true");
        $(`.tab-content-is[data-vtab=${tabSelected}]`).show();
    };
    const filterFinancialStatement = (index) => {
        $(".statement_year.active, .data_point_value.active").removeClass("active");
        $(".data-table thead").each(function () {
            $(this)
                .find(".statement_year")
                .eq(index - 1)
                .addClass("active");
        });
        $(".data-table tr").each(function () {
            $(this)
                .find(".data_point_value")
                .eq(index - 1)
                .addClass("active");
        });
    };
    $(() => {
        // TODO Does not account for resizing window
        // Mobile-only functions
        if (getViewportIsMobile()) {
            // Left-align financial statement navigation link on click
            if ($(".company_new_financials").length > 0) {
                const $overflowParent = $(".cmp-tabbed-nav-is");
                $overflowParent.find("a").on("click", function () {
                    $overflowParent.scrollLeft($(this).position().left);
                });
            }
            // Data_point filtering for mobile
            $(".company_new_financials .statement_year").on("click", function () {
                const selected_index = $(this).index();
                filterFinancialStatement(selected_index);
            });
            // Mobile ready
            $(() => {
                filterFinancialStatement(1);
            });
            // Mobile dropdown parent-level buttons
            $('.company_new_financials [role="menubar"] > button').on("click", function (cl) {
                cl.stopPropagation();
                const $parent = $(this).parent('[role="menubar"]');
                if ($parent.hasClass("open")) {
                    $parent.removeClass("open");
                    $parent.attr("aria-expanded", "false");
                }
                else {
                    $parent.addClass("open");
                    $parent.attr("aria-expanded", "true");
                }
            });
            // Mobile-only dropdown option button functions
            $(".company_new_financials ul button").on("click", function () {
                const $this = $(this);
                const $parents = $this.parents('[role="menubar"]').first();
                const $children = $parents.children("button");
                const thisText = $this.text();
                $parents.removeClass("open");
                $children.html(thisText);
                $children.focus();
            });
        }
        let tabFocus = 0;
        $(".tablist").on("keydown", function (ke) {
            const tabs = $(this).find(".tab button");
            const which = ke.which;
            if (which === keycode.codes.left || which === keycode.codes.up || which === keycode.codes.right || which === keycode.codes.down) {
                if (which === keycode.codes.right || which === keycode.codes.down) {
                    tabFocus = tabFocus + 1;
                    // If we're at the end
                    if (tabFocus >= tabs.length) {
                        // Go to the start
                        tabFocus = 0;
                    }
                }
                else {
                    // Move left, up
                    tabFocus = tabFocus - 1;
                    // If we're at the start
                    if (tabFocus < 0) {
                        // Move to the end
                        tabFocus = tabs.length - 1;
                    }
                }
                tabs[tabFocus].focus();
            }
        });
        // Tabbed navigation
        $(".tabbed-nav").each(function () {
            const $this = $(this);
            if ($this.children("tab.active").length > 0) {
                changeTab($this.children("tab.active"));
            }
            else {
                changeTab($this.children("li:first-child"));
            }
        });
        const $tabbedNavLi = $(".tabbed-nav li");
        if ($tabbedNavLi.length > 0) {
            if ($tabbedNavLi.length <= 1) {
                $(".tabbed-nav button").addClass("li_first").removeClass("active");
            }
            $tabbedNavLi
                .on("click", function (cl) {
                cl.preventDefault();
                const $this = $(this);
                // TODO
                // @ts-expect-error Ignore
                getWindowDigitalData().page.pageInfo["companyProfile"]["financialSelected"] = $this.text();
                try {
                    getWindowUnderscoreSatellite().track("companyProfileFinancialSelected");
                }
                catch (er) {
                    dnbComLog(LogSeverity.ERROR, er);
                }
                changeTab($this);
                if ($tabbedNavLi.length <= 1) {
                    $tabbedNavLi.removeClass("active");
                }
            })
                .on("keypress", function (ke) {
                ke.preventDefault();
                changeTab($(this));
            });
        }
        const $tabbedNavIsLi = $(".tabbed-nav-is li");
        // Vertical navigation inside of first tab
        if ($tabbedNavIsLi.length > 0) {
            changeTabIs($(".tabbed-nav-is li:first").find("button"));
            // Click on vertical nav
            $tabbedNavIsLi
                .on("click", function (cl) {
                cl.preventDefault();
                const $this = $(this);
                const text = $this.text();
                // TODO
                // @ts-expect-error Ignore
                getWindowDigitalData().page.pageInfo["companyProfile"]["financialSelected"] = text.slice(0, window.Math.max(0, text.indexOf(":")));
                try {
                    getWindowUnderscoreSatellite().track("companyProfileFinancialSelected");
                }
                catch (er) {
                    dnbComLog(LogSeverity.ERROR, er);
                }
                changeTabIs($this.find("button"));
            })
                .on("keypress", function () {
                changeTabIs($(this).find("button"));
            });
        }
    });
};
export { companyNewFinancials };
